import React, { Component } from 'react';
import $ from 'jquery';

async function saveFitDataToSQLAzure(state) {
    var ret;

    // Get Step 5 selections in array
    var Step5of5 = state.Step5of5.map(function (el) { return el.id; });

    // Sort by ASC
    Step5of5.sort();

    // Data to be sent to the server 
    var dataToPassToService = {
        Email: state.email,
        SizeLeft: state.Step1of5,
        SizeRight: state.Step1of5,
        SizeAltLeft: state.Step2of5,
        SizeAltRight: state.Step2of5,
        Width: state.Step3of5,
        ToeShape: state.Step4of5,
        Bunion: JSON.stringify(Step5of5).replaceAll('"', '').replaceAll('[', '').replaceAll(']', ''),
        AlgorithmSizeL: String(state.algorithmSizeL),
        AlgorithmSizeR: String(state.algorithmSizeR),
        AlgorithmWidthL: state.algorithmWidthL,
        AlgorithmWidthR: state.algorithmWidthR,
    }

    //Call to Server Side C# Controller Function
    await $.ajax({
        //url: 'https://localhost:7188/SQLAzureInsert',
        url: '/SQLAzureInsert',
        type: 'POST',
        data: JSON.stringify(dataToPassToService),
        contentType: 'application/json;charset=utf-8'
    }).done(function (data) {
        //HANDLE ERROR FROM SERVER
        if (data.status == "Success!") {
            console.log(data);
            ret = true;
        }
        else {
            //HANDLE ERROR FROM SERVER
            ret = false;
            console.log(data);
        }
    }).fail(function (data) {
        //HANDLE ERROR FROM AJAX
        ret = false;
        console.log(data);
    });

    //Return
    return new Promise(resolve => resolve(ret));
}

async function CreateKlaviyoProfile(state) {
    var ret;

    // Get Step 5 selections in array
    var Step5of5 = state.Step5of5.map(function (el) { return el.id; });

    // Sort by ASC
    Step5of5.sort();

    // Data to be sent to the server 
    var dataToPassToService = {
        Email: state.email,
        SizeLeft: state.Step1of5,
        SizeRight: state.Step1of5,
        SizeAltLeft: state.Step2of5,
        SizeAltRight: state.Step2of5,
        Width: state.Step3of5,
        ToeShape: state.Step4of5,
        Bunion: JSON.stringify(Step5of5).replaceAll('"', '').replaceAll('[', '').replaceAll(']', ''),
        AlgorithmSizeL: String(state.algorithmSizeL),
        AlgorithmSizeR: String(state.algorithmSizeR),
        AlgorithmWidthL: state.algorithmWidthL,
        AlgorithmWidthR: state.algorithmWidthR,
    }

    //Call to Server Side C# Controller Function
    await $.ajax({
        //url: 'https://localhost:7188/CreateKlaviyoProfile', 
        url: '/CreateKlaviyoProfile',
        type: 'POST',
        data: JSON.stringify(dataToPassToService),
        contentType: 'application/json;charset=utf-8'
    }).done(function (data) {
        //HANDLE ERROR FROM SERVER
        if (data.status == "Success!") {
            console.log(data);
            ret = true;
        }
        else {
            //HANDLE ERROR FROM SERVER
            ret = false;
            console.log(data);
        }
    }).fail(function (data) {
        //HANDLE ERROR FROM AJAX
        ret = false;
        console.log(data);
    });

    //Return
    return new Promise(resolve => resolve(ret));
}

async function SendEmail(state) {
    var ret;

    // Data to be sent to the server 
    var dataToPassToService = {
        Email: state.email,
        SizeLeft: String(state.algorithmSizeL),
        SizeRight: String(state.algorithmSizeR),
        WidthLeft: state.algorithmWidthL,
        WidthRight: state.algorithmWidthR,
    }

    //Call to Server Side C# Controller Function
    await $.ajax({
        //url: 'https://localhost:7188/SendEmail', 
        url: '/SendEmail',
        type: 'POST',
        data: JSON.stringify(dataToPassToService),
        contentType: 'application/json;charset=utf-8'
    }).done(function (data) {
        //HANDLE ERROR FROM SERVER
        if (data.status == "Success!") {
            console.log(data);
            ret = true;
        }
        else {
            //HANDLE ERROR FROM SERVER
            ret = false;
            console.log(data);
        }
    }).fail(function (data) {
        //HANDLE ERROR FROM AJAX
        ret = false;
        console.log(data);
    });

    //Return
    return new Promise(resolve => resolve(ret));
}

// React Component
export class MultiStep extends React.Component {

    constructor(props) {
        super(props);
    }

    //Init State Object
    state = {
        step: 1,
        Step1of5: '',
        Step2of5: '',
        Step3of5: '',
        Step4of5: '',
        Step5of5: [],
        email: '',
        algorithmSizeL: '',
        algorithmSizeR: '',
        algorithmWidthL: '',
        algorithmWidthR: '',
    }

    // go back to previous step
    prevStep = () => {
        const { step } = this.state;
        this.setState({ step: step - 1 });
        //Scroll to Top
        //if (step < 3) {
        //    document.body.scrollIntoView({ behavior: "smooth" });
        //}
        //console.log(step);
    }

    // proceed to the next step
    nextStep = () => {
        const { step } = this.state;
        this.setState({ step: step + 1 });
        this.setState({ step: step + 1 });

        //Handle Steps 
        if (step == 7) {

            //Call algorithm
            this.algorithm();

            //Call SQL saveFitDataToSQLAzure 
            saveFitDataToSQLAzure(this.state);

            //'Create Klaviyo Profile & Event
            CreateKlaviyoProfile(this.state);

            //'Async Function Call - EMAIL 
            SendEmail(this.state);

            //show last submission?, confirm submission?
        }

        //Scroll to Top
        //if (step < 3) {
        //    setTimeout(() => {
        //        document.body.scrollIntoView({ behavior: "smooth" }); 
        //    }, "500")
        //}
        //console.log(step);
    }

    // Step5of5 - Check for active class
    handleCheck(val) {
        return (this.state["Step5of5"].some(location => location.id === val) == true);
    }

    // Increase the Width by 1 size
    increaseWidth(val) {
        if (val == 'Narrow - A') {
            val = 'Standard - B';
        }
        else if (val == 'Standard - B') {
            val = 'Wide - C';
        }
        else if (val == 'Wide - C') {
            val = 'Extra Wide - D';
        }
        return val;
    }

    // Handle fields change
    handleChange = input => e => {

        //Handle State Updates
        if (input == "Step5of5") {
            //Get From DOM
            var val = e.currentTarget.getAttribute('value');
            var bumpLocation = e.currentTarget.getAttribute('bump');

            //Toggle - Remove from State if already exists.
            if (this.state["Step5of5"].some(location => location.id === val)) {
                //Remove 
                this.state["Step5of5"] = this.state["Step5of5"].filter(object => {
                    return object.id !== val;
                });
            }
            else {
                //Append 
                //Toggle No Bumps
                if (bumpLocation == 'none') { this.state["Step5of5"] = []; }
                else {
                    this.state["Step5of5"] = this.state["Step5of5"].filter(object => {
                        return object.id != 'G';
                    });
                }
                this.state["Step5of5"].push({ id: val, bumpLocation: bumpLocation });
            }

            //FORCE UPDATE
            this.forceUpdate();
        }
        else if (input == "email") {
            this.setState({ [input]: e.currentTarget.value });
        }
        else {
            this.setState({ [input]: e.currentTarget.getAttribute('value') });
        }

        //Format
        if (input == "Step1of5") {
            this.nextStep();

            //FORCE UPDATE 
            this.forceUpdate();
        }
        if (input == "Step2of5") {
            this.nextStep();
        }
        if (input == "Step3of5") {
            this.nextStep();
            //console.log(this.state['Step3of5']);
        }
        if (input == "Step4of5") {
            this.nextStep();
            //ENABLE RIGHT ARROW BUTTON
        }
    }

    //['Step1of5'] - What's your usual shoe size?
    //['Step3of5'] - What best describes your width?
    //['Step4of5'] - If Greek + Width is Wide or Extra Wide = increase size, 1/2 size up
    //['Step5of5'] - Any answer other than none = Increase Width
    algorithm() {

        var widthCorD = false;
        var SizeLeft = parseFloat(this.state['Step1of5']);
        var SizeRight = parseFloat(this.state['Step1of5']);
        var WidthLeft = this.state['Step3of5'];
        var WidthRight = this.state['Step3of5'];

        //If Greek + Width is Wide or Extra Wide = increase size, 1/2 size up
        if (this.state['Step4of5'] == 'Greek' && (this.state['Step3of5'] == 'Wide - C' || this.state['Step3of5'] == 'Extra Wide - D')) {
            SizeLeft += 0.5;
            SizeRight += 0.5;
        }
        //Any answer other than none = Increase Width in respective foot
        if (this.state["Step5of5"].some(location => location.bumpLocation === "none")) {
            //Do Nothing
        }
        else if (this.state["Step5of5"].some(location => location.bumpLocation === "both")) {
            WidthLeft = this.increaseWidth(WidthLeft);
            WidthRight = this.increaseWidth(WidthRight);
        }
        else if (this.state["Step5of5"].some(location => location.bumpLocation === "left")) {
            WidthLeft = this.increaseWidth(WidthLeft);
            WidthRight = this.increaseWidth(WidthRight);
        }
        else if (this.state["Step5of5"].some(location => location.bumpLocation === "right")) {
            WidthLeft = this.increaseWidth(WidthLeft);
            WidthRight = this.increaseWidth(WidthRight);
        }

        //If the user Selects Width A or B then always set the results as Width B
        if (WidthLeft == 'Narrow - A' || WidthRight == 'Narrow - A') {
            WidthLeft = 'Standard - B';
            WidthRight = 'Standard - B';
        }

        //Width - If the user Selects Width C or D then display C or D with the note -
        if (WidthLeft == 'Wide - C' || WidthLeft == 'Extra Wide - D' || WidthRight == 'Wide - C' || WidthRight == 'Extra Wide - D') {
            widthCorD = true;
        }

        // Save algorithm results
        this.state["algorithmSizeL"] = SizeLeft;
        this.state["algorithmSizeR"] = SizeRight;
        this.state["algorithmWidthL"] = WidthLeft;
        this.state["algorithmWidthR"] = WidthRight;

        // return
        return { SizeLeft: SizeLeft, SizeRight: SizeRight, WidthLeft: WidthLeft, WidthRight: WidthRight, widthCorD: widthCorD }
    }

    //shopNow Button Link
    shopNow = () => {
        window.open('https://antoniasaintny.com/collections/all/');
    }

    // Render React Component
    render() {
        const { step } = this.state;

        // Multi- Step UI
        switch (step) {
            case 1:
                return (
                    //LandingScreenContainer
                    <div className="LandingScreenContainer">
                        <div className="LandingScreenIntroContainer">
                            <div className="LandingScreenIntro">
                                <h1 id="quiz-kit-intro-title" >Take a quiz to help you find your perfect fit</h1>

                                <div className="d-flex flex-column">
                                    <p>We recognize that every body is unique and one size does not fit all. Take our Fit Quiz to find the right shoe for you and your needs.</p>
                                    <div>
                                        <p className="mb-0"><b>Did you know that 88% of women wear shoes that are too small for her feet?</b></p>
                                        <p>There is no reliable "standard" size chart that is the same around the world. A size 10.5 from one company is likely quite different from another.</p>
                                    </div>
                                    <div>
                                        <p className="mb-0"><b>To make fit even more challenging, 60% of people have two differently-sized feet!</b></p>
                                        <p>When more than half of the population has two differently sized feet and no other shoe company offers the option to order a separate size per foot, we knew we had to do something about it.</p>
                                    </div>
                                </div>

                                <button onClick={this.nextStep} className="LandingScreenButton" kind="fill">Take the quiz</button>
                            </div>
                            <div id="quiz-kit-intro-overlay" className="sc-fznJRM bTIjTR" ></div>
                        </div>
                        <div id="quiz-kit-intro-content-image" >

                            <img srcSet="https://d33x1o3gj9io8i.cloudfront.net/images/3194/sm_MMcwJpJlSMe6gSA1zpyH 1200w,
                                    https://d33x1o3gj9io8i.cloudfront.net/images/3194/md_MMcwJpJlSMe6gSA1zpyH 1400w"
                                sizes="(max-width: 1200px) 1200px,1400px"
                                src="https://d33x1o3gj9io8i.cloudfront.net/images/3194/MMcwJpJlSMe6gSA1zpyH"
                                alt="Take a quiz to help you find your perfect fit"></img>
                        </div>
                    </div>
                )
            case 2:
                return (
                    <div className="StepContainer" >
                        <div className="StepQuestion">
                            <h3 className="" delay="0">1 of 5</h3>
                            <h1 className="" delay="150">What's your usual shoe size?</h1>
                        </div>
                        <div class="ShoeSizeSelectorContainer" delay="300">
                            <fluent-card class={"ShoeSizeSelectorCard " + (this.state['Step1of5'] == "4" ? "active-class" : "")} onClick={this.handleChange('Step1of5')} value="4">4</fluent-card>
                            <fluent-card class={"ShoeSizeSelectorCard " + (this.state['Step1of5'] == "4.5" ? "active-class" : "")} onClick={this.handleChange('Step1of5')} value="4.5">4.5</fluent-card>
                            <fluent-card class={"ShoeSizeSelectorCard " + (this.state['Step1of5'] == "5" ? "active-class" : "")} onClick={this.handleChange('Step1of5')} value="5">5</fluent-card>
                            <fluent-card class={"ShoeSizeSelectorCard " + (this.state['Step1of5'] == "5.5" ? "active-class" : "")} onClick={this.handleChange('Step1of5')} value="5.5">5.5</fluent-card>
                            <fluent-card class={"ShoeSizeSelectorCard " + (this.state['Step1of5'] == "6" ? "active-class" : "")} onClick={this.handleChange('Step1of5')} value="6">6</fluent-card>
                            <fluent-card class={"ShoeSizeSelectorCard " + (this.state['Step1of5'] == "6.5" ? "active-class" : "")} onClick={this.handleChange('Step1of5')} value="6.5">6.5</fluent-card>
                            <fluent-card class={"ShoeSizeSelectorCard " + (this.state['Step1of5'] == "7" ? "active-class" : "")} onClick={this.handleChange('Step1of5')} value="7">7</fluent-card>
                            <fluent-card class={"ShoeSizeSelectorCard " + (this.state['Step1of5'] == "7.5" ? "active-class" : "")} onClick={this.handleChange('Step1of5')} value="7.5">7.5</fluent-card>
                            <fluent-card class={"ShoeSizeSelectorCard " + (this.state['Step1of5'] == "8" ? "active-class" : "")} onClick={this.handleChange('Step1of5')} value="8">8</fluent-card>
                            <fluent-card class={"ShoeSizeSelectorCard " + (this.state['Step1of5'] == "8.5" ? "active-class" : "")} onClick={this.handleChange('Step1of5')} value="8.5">8.5</fluent-card>
                            <fluent-card class={"ShoeSizeSelectorCard " + (this.state['Step1of5'] == "9" ? "active-class" : "")} onClick={this.handleChange('Step1of5')} value="9">9</fluent-card>
                            <fluent-card class={"ShoeSizeSelectorCard " + (this.state['Step1of5'] == "9.5" ? "active-class" : "")} onClick={this.handleChange('Step1of5')} value="9.5">9.5</fluent-card>
                            <fluent-card class={"ShoeSizeSelectorCard " + (this.state['Step1of5'] == "10" ? "active-class" : "")} onClick={this.handleChange('Step1of5')} value="10">10</fluent-card>
                            <fluent-card class={"ShoeSizeSelectorCard " + (this.state['Step1of5'] == "10.5" ? "active-class" : "")} onClick={this.handleChange('Step1of5')} value="10.5">10.5</fluent-card>
                            <fluent-card class={"ShoeSizeSelectorCard " + (this.state['Step1of5'] == "11" ? "active-class" : "")} onClick={this.handleChange('Step1of5')} value="11">11</fluent-card>
                            <fluent-card class={"ShoeSizeSelectorCard " + (this.state['Step1of5'] == "11.5" ? "active-class" : "")} onClick={this.handleChange('Step1of5')} value="11.5">11.5</fluent-card>
                            <fluent-card class={"ShoeSizeSelectorCard " + (this.state['Step1of5'] == "12" ? "active-class" : "")} onClick={this.handleChange('Step1of5')} value="12">12</fluent-card>
                            <fluent-card class={"ShoeSizeSelectorCard " + (this.state['Step1of5'] == "12.5" ? "active-class" : "")} onClick={this.handleChange('Step1of5')} value="12.5">12.5</fluent-card>
                            <fluent-card class={"ShoeSizeSelectorCard " + (this.state['Step1of5'] == "13" ? "active-class" : "")} onClick={this.handleChange('Step1of5')} value="13">13</fluent-card>
                        </div>
                        <div class="QuestionNavigationContainer" delay="450">
                            <button class={"QuestionNavigationButton " + (this.state['Step1of5'] == "" ? "disabled" : "false")} onClick={this.state['Step1of5'] != "" ? this.nextStep : ""}>
                                <span>Next</span>
                                <svg width="16px" height="16px" viewBox="0 0 14 12" version="1.1"><title>Next</title><g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"><g id="Next/Back-Buttons" transform="translate(-263.000000, -54.000000)" fill="#000000" fillRule="nonzero" stroke="#000000"><g id="Group-3-Copy" transform="translate(0.000000, 50.000000)"><g id="Group-2" transform="translate(214.000000, 0.000000)"><path d="M56.0281414,4 C56.1030387,4.00628851 56.1761774,4.03773106 56.2334898,4.09432766 L60.9032854,8.70580175 C61.0322382,8.83314409 61.0322382,9.03960679 60.9032854,9.16694917 C60.7743325,9.29429148 60.5652587,9.29429148 60.4363058,9.16694917 L56.3300891,5.11198996 L56.3310405,16.4516973 L56.3257208,16.5103293 C56.2977637,16.6624347 56.1629516,16.7777778 56.000859,16.7777778 C55.8184884,16.7777778 55.6706443,16.6317903 55.6706317,16.4516973 L55.6696803,5.11198996 L51.5636942,9.16694917 C51.4490694,9.28014233 51.2711392,9.29271938 51.1424466,9.2046802 L51.0967146,9.16694917 C50.9677618,9.03960679 50.9677618,8.83314409 51.0967146,8.70580175 L55.7665102,4.09432766 C55.8238226,4.03773106 55.8969614,4.00628851 55.9718586,4 L56.0281414,4 Z" id="Path-Copy" transform="translate(56.000000, 10.388889) rotate(-270.000000) translate(-56.000000, -10.388889) "></path></g></g></g></g></svg>
                            </button>
                        </div>
                    </div>
                )
            case 3:
                return (
                    <div className="StepContainer" >
                        <div className="StepQuestion">
                            <h3 delay="0">2 of 5</h3>
                            <h1 delay="150">What other size do you try for a better fit? [Optional]</h1>
                        </div>
                        <div class="ShoeSizeSelectorContainer2" delay="400">
                            <fluent-card class={"ShoeSizeSelectorCard " + (this.state['Step2of5'] == "4" ? "active-class" : "")} onClick={this.handleChange('Step2of5')} value="4">4</fluent-card>
                            <fluent-card class={"ShoeSizeSelectorCard " + (this.state['Step2of5'] == "4.5" ? "active-class" : "")} onClick={this.handleChange('Step2of5')} value="4.5">4.5</fluent-card>
                            <fluent-card class={"ShoeSizeSelectorCard " + (this.state['Step2of5'] == "5" ? "active-class" : "")} onClick={this.handleChange('Step2of5')} value="5">5</fluent-card>
                            <fluent-card class={"ShoeSizeSelectorCard " + (this.state['Step2of5'] == "5.5" ? "active-class" : "")} onClick={this.handleChange('Step2of5')} value="5.5">5.5</fluent-card>
                            <fluent-card class={"ShoeSizeSelectorCard " + (this.state['Step2of5'] == "6" ? "active-class" : "")} onClick={this.handleChange('Step2of5')} value="6">6</fluent-card>
                            <fluent-card class={"ShoeSizeSelectorCard " + (this.state['Step2of5'] == "6.5" ? "active-class" : "")} onClick={this.handleChange('Step2of5')} value="6.5">6.5</fluent-card>
                            <fluent-card class={"ShoeSizeSelectorCard " + (this.state['Step2of5'] == "7" ? "active-class" : "")} onClick={this.handleChange('Step2of5')} value="7">7</fluent-card>
                            <fluent-card class={"ShoeSizeSelectorCard " + (this.state['Step2of5'] == "7.5" ? "active-class" : "")} onClick={this.handleChange('Step2of5')} value="7.5">7.5</fluent-card>
                            <fluent-card class={"ShoeSizeSelectorCard " + (this.state['Step2of5'] == "8" ? "active-class" : "")} onClick={this.handleChange('Step2of5')} value="8">8</fluent-card>
                            <fluent-card class={"ShoeSizeSelectorCard " + (this.state['Step2of5'] == "8.5" ? "active-class" : "")} onClick={this.handleChange('Step2of5')} value="8.5">8.5</fluent-card>
                            <fluent-card class={"ShoeSizeSelectorCard " + (this.state['Step2of5'] == "9" ? "active-class" : "")} onClick={this.handleChange('Step2of5')} value="9">9</fluent-card>
                            <fluent-card class={"ShoeSizeSelectorCard " + (this.state['Step2of5'] == "9.5" ? "active-class" : "")} onClick={this.handleChange('Step2of5')} value="9.5">9.5</fluent-card>
                            <fluent-card class={"ShoeSizeSelectorCard " + (this.state['Step2of5'] == "10" ? "active-class" : "")} onClick={this.handleChange('Step2of5')} value="10">10</fluent-card>
                            <fluent-card class={"ShoeSizeSelectorCard " + (this.state['Step2of5'] == "10.5" ? "active-class" : "")} onClick={this.handleChange('Step2of5')} value="10.5">10.5</fluent-card>
                            <fluent-card class={"ShoeSizeSelectorCard " + (this.state['Step2of5'] == "11" ? "active-class" : "")} onClick={this.handleChange('Step2of5')} value="11">11</fluent-card>
                            <fluent-card class={"ShoeSizeSelectorCard " + (this.state['Step2of5'] == "11.5" ? "active-class" : "")} onClick={this.handleChange('Step2of5')} value="11.5">11.5</fluent-card>
                            <fluent-card class={"ShoeSizeSelectorCard " + (this.state['Step2of5'] == "12" ? "active-class" : "")} onClick={this.handleChange('Step2of5')} value="12">12</fluent-card>
                            <fluent-card class={"ShoeSizeSelectorCard " + (this.state['Step2of5'] == "12.5" ? "active-class" : "")} onClick={this.handleChange('Step2of5')} value="12.5">12.5</fluent-card>
                            <fluent-card class={"ShoeSizeSelectorCard " + (this.state['Step2of5'] == "13" ? "active-class" : "")} onClick={this.handleChange('Step2of5')} value="13">13</fluent-card>
                        </div>
                        <div class="QuestionNavigationContainer" delay="450">
                            <button class="QuestionNavigationButton" onClick={this.prevStep} style={{ marginRight: '150px' }}>
                                <span>Back</span>
                                <svg width="16px" height="16px" viewBox="0 0 14 12" version="1.1"><title>Back</title><g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"><g id="Next/Back-Buttons" transform="translate(0.000000, -54.000000)" fill="#000000" fillRule="nonzero" stroke="#000000"><g id="Group" transform="translate(0.000000, 50.000000)"><path d="M7.02814142,4 C7.10303865,4.00628851 7.17617741,4.03773106 7.2334898,4.09432766 L11.9032854,8.70580175 C12.0322382,8.83314409 12.0322382,9.03960679 11.9032854,9.16694917 C11.7743325,9.29429148 11.5652587,9.29429148 11.4363058,9.16694917 L7.33008912,5.11198996 L7.33104051,16.4516973 L7.32572085,16.5103293 C7.29776369,16.6624347 7.1629516,16.7777778 7.00085901,16.7777778 C6.81848843,16.7777778 6.67064429,16.6317903 6.67063168,16.4516973 L6.6696803,5.11198996 L2.56369419,9.16694917 C2.44906944,9.28014233 2.27113919,9.29271938 2.14244655,9.2046802 L2.09671464,9.16694917 C1.96776179,9.03960679 1.96776179,8.83314409 2.09671464,8.70580175 L6.76651023,4.09432766 C6.82382262,4.03773106 6.89696138,4.00628851 6.97185861,4 L7.02814142,4 Z" id="Path" transform="translate(7.000000, 10.388889) rotate(-90.000000) translate(-7.000000, -10.388889) "></path></g></g></g></svg>
                            </button>
                            <button class="QuestionNavigationButton" onClick={this.nextStep}>
                                <span>Next</span>
                                <svg width="16px" height="16px" viewBox="0 0 14 12" version="1.1"><title>Next</title><g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"><g id="Next/Back-Buttons" transform="translate(-263.000000, -54.000000)" fill="#000000" fillRule="nonzero" stroke="#000000"><g id="Group-3-Copy" transform="translate(0.000000, 50.000000)"><g id="Group-2" transform="translate(214.000000, 0.000000)"><path d="M56.0281414,4 C56.1030387,4.00628851 56.1761774,4.03773106 56.2334898,4.09432766 L60.9032854,8.70580175 C61.0322382,8.83314409 61.0322382,9.03960679 60.9032854,9.16694917 C60.7743325,9.29429148 60.5652587,9.29429148 60.4363058,9.16694917 L56.3300891,5.11198996 L56.3310405,16.4516973 L56.3257208,16.5103293 C56.2977637,16.6624347 56.1629516,16.7777778 56.000859,16.7777778 C55.8184884,16.7777778 55.6706443,16.6317903 55.6706317,16.4516973 L55.6696803,5.11198996 L51.5636942,9.16694917 C51.4490694,9.28014233 51.2711392,9.29271938 51.1424466,9.2046802 L51.0967146,9.16694917 C50.9677618,9.03960679 50.9677618,8.83314409 51.0967146,8.70580175 L55.7665102,4.09432766 C55.8238226,4.03773106 55.8969614,4.00628851 55.9718586,4 L56.0281414,4 Z" id="Path-Copy" transform="translate(56.000000, 10.388889) rotate(-270.000000) translate(-56.000000, -10.388889) "></path></g></g></g></g></svg>
                            </button>
                        </div>
                    </div>
                )
            case 4:
                return (
                    <div className="StepContainer">
                        <div className="StepQuestion">
                            <h3 delay="0">3 of 5</h3>
                            <h1 delay="150">What best describes your width?</h1>
                        </div>
                        <div className="ShoeSizeSelectorContainer" delay="400">
                            <button width="100" className={"WidthSelectorCard " + (this.state['Step3of5'] == "Narrow - A" ? "active-class" : "")} onClick={this.handleChange('Step3of5')} value="Narrow - A">
                                <div width="100" shape="circle" className="WidthImageContainerContainer" >
                                    <div className="WidthImageContainer">
                                        <img className="WidthImage" src="https://d33x1o3gj9io8i.cloudfront.net/images/3194/1G9vdvmsRmaVI6q419Ek" alt="Narrow"></img>
                                    </div>
                                </div>
                                <h1>Narrow</h1>
                            </button>
                            <button width="100" className={"WidthSelectorCard " + (this.state['Step3of5'] == "Standard - B" ? "active-class" : "")} onClick={this.handleChange('Step3of5')} value="Standard - B">
                                <div width="100" shape="circle" className="WidthImageContainerContainer" >
                                    <div className="WidthImageContainer">
                                        <img className="WidthImage" src="https://d33x1o3gj9io8i.cloudfront.net/images/3194/xbbft6bHTkeAFrIMDbjI" alt="Standard"></img>
                                    </div>
                                </div>
                                <h1>Standard</h1>
                            </button>
                            <button width="100" className={"WidthSelectorCard " + (this.state['Step3of5'] == "Wide - C" ? "active-class" : "")} onClick={this.handleChange('Step3of5')} value="Wide - C">
                                <div width="100" shape="circle" className="WidthImageContainerContainer" >
                                    <div className="WidthImageContainer">
                                        <img className="WidthImage" src="https://d33x1o3gj9io8i.cloudfront.net/images/3194/Xwm956yzRJxtXKgysd8W" alt="Wide"></img>
                                    </div>
                                </div>
                                <h1>Wide</h1>
                            </button>
                            <button width="100" className={"WidthSelectorCard " + (this.state['Step3of5'] == "Extra Wide - D" ? "active-class" : "")} onClick={this.handleChange('Step3of5')} value="Extra Wide - D">
                                <div width="100" shape="circle" className="WidthImageContainerContainer" >
                                    <div className="WidthImageContainer">
                                        <img className="WidthImage" src="https://d33x1o3gj9io8i.cloudfront.net/images/3194/I7Dz25giSuOIvuWpAgv1" alt="Extra Wide"></img>
                                    </div>
                                </div>
                                <h1>Extra Wide</h1>
                            </button>
                        </div>
                        <div className="QuestionNavigationContainer" delay="450">
                            <button className="QuestionNavigationButton" onClick={this.prevStep} style={{ marginRight: '150px' }}>
                                <span>Back</span>
                                <svg width="16px" height="16px" viewBox="0 0 14 12" version="1.1"><title>Back</title><g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"><g id="Next/Back-Buttons" transform="translate(0.000000, -54.000000)" fill="#000000" fillRule="nonzero" stroke="#000000"><g id="Group" transform="translate(0.000000, 50.000000)"><path d="M7.02814142,4 C7.10303865,4.00628851 7.17617741,4.03773106 7.2334898,4.09432766 L11.9032854,8.70580175 C12.0322382,8.83314409 12.0322382,9.03960679 11.9032854,9.16694917 C11.7743325,9.29429148 11.5652587,9.29429148 11.4363058,9.16694917 L7.33008912,5.11198996 L7.33104051,16.4516973 L7.32572085,16.5103293 C7.29776369,16.6624347 7.1629516,16.7777778 7.00085901,16.7777778 C6.81848843,16.7777778 6.67064429,16.6317903 6.67063168,16.4516973 L6.6696803,5.11198996 L2.56369419,9.16694917 C2.44906944,9.28014233 2.27113919,9.29271938 2.14244655,9.2046802 L2.09671464,9.16694917 C1.96776179,9.03960679 1.96776179,8.83314409 2.09671464,8.70580175 L6.76651023,4.09432766 C6.82382262,4.03773106 6.89696138,4.00628851 6.97185861,4 L7.02814142,4 Z" id="Path" transform="translate(7.000000, 10.388889) rotate(-90.000000) translate(-7.000000, -10.388889) "></path></g></g></g></svg>
                            </button>
                            <button className={"QuestionNavigationButton " + (this.state['Step3of5'] == "" ? "disabled" : "false")} onClick={this.state['Step3of5'] != "" ? this.nextStep : ""}>
                                <span>Next</span>
                                <svg width="16px" height="16px" viewBox="0 0 14 12" version="1.1"><title>Next</title><g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"><g id="Next/Back-Buttons" transform="translate(-263.000000, -54.000000)" fill="#000000" fillRule="nonzero" stroke="#000000"><g id="Group-3-Copy" transform="translate(0.000000, 50.000000)"><g id="Group-2" transform="translate(214.000000, 0.000000)"><path d="M56.0281414,4 C56.1030387,4.00628851 56.1761774,4.03773106 56.2334898,4.09432766 L60.9032854,8.70580175 C61.0322382,8.83314409 61.0322382,9.03960679 60.9032854,9.16694917 C60.7743325,9.29429148 60.5652587,9.29429148 60.4363058,9.16694917 L56.3300891,5.11198996 L56.3310405,16.4516973 L56.3257208,16.5103293 C56.2977637,16.6624347 56.1629516,16.7777778 56.000859,16.7777778 C55.8184884,16.7777778 55.6706443,16.6317903 55.6706317,16.4516973 L55.6696803,5.11198996 L51.5636942,9.16694917 C51.4490694,9.28014233 51.2711392,9.29271938 51.1424466,9.2046802 L51.0967146,9.16694917 C50.9677618,9.03960679 50.9677618,8.83314409 51.0967146,8.70580175 L55.7665102,4.09432766 C55.8238226,4.03773106 55.8969614,4.00628851 55.9718586,4 L56.0281414,4 Z" id="Path-Copy" transform="translate(56.000000, 10.388889) rotate(-270.000000) translate(-56.000000, -10.388889) "></path></g></g></g></g></svg>
                            </button>
                        </div>
                    </div>
                )
            case 5:
                return (
                    <div className="StepContainer">
                        <div className="StepQuestion">
                            <h3 delay="0">4 of 5</h3>
                            <h1 delay="150">What best describes your toes?</h1>
                        </div>
                        <div className="ShoeSizeSelectorContainer2" delay="400">
                            <button width="100" className={"WidthSelectorCard " + (this.state['Step4of5'] == "Roman" ? "active-class" : "")} onClick={this.handleChange('Step4of5')} value="Roman">
                                <div width="100" shape="circle" className="WidthImageContainerContainer" >
                                    <div className="WidthImageContainer">
                                        <img className="WidthImage" src="https://d33x1o3gj9io8i.cloudfront.net/images/3194/jYNiDmsiR0iPtojAAcdv" alt="Roman"></img>
                                    </div>
                                </div>
                                <h1>Roman</h1>
                            </button>
                            <button width="100" className={"WidthSelectorCard " + (this.state['Step4of5'] == "Germanic" ? "active-class" : "")} onClick={this.handleChange('Step4of5')} value="Germanic">
                                <div width="100" shape="circle" className="WidthImageContainerContainer" >
                                    <div className="WidthImageContainer">
                                        <img className="WidthImage" src="https://d33x1o3gj9io8i.cloudfront.net/images/3194/BVHwE3svQl28TlNToyhw" alt="Germanic"></img>
                                    </div>
                                </div>
                                <h1>Germanic</h1>
                            </button>
                            <button width="100" className={"WidthSelectorCard " + (this.state['Step4of5'] == "Greek" ? "active-class" : "")} onClick={this.handleChange('Step4of5')} value="Greek">
                                <div width="100" shape="circle" className="WidthImageContainerContainer" >
                                    <div className="WidthImageContainer">
                                        <img className="WidthImage" src="https://d33x1o3gj9io8i.cloudfront.net/images/3194/hWfTdaNETaKlVMOrGYIr" alt="Greek"></img>
                                    </div>
                                </div>
                                <h1>Greek</h1>
                            </button>
                            <button width="100" className={"WidthSelectorCard " + (this.state['Step4of5'] == "Egyptian" ? "active-class" : "")} onClick={this.handleChange('Step4of5')} value="Egyptian">
                                <div width="100" shape="circle" className="WidthImageContainerContainer" >
                                    <div className="WidthImageContainer">
                                        <img className="WidthImage" src="https://d33x1o3gj9io8i.cloudfront.net/images/3194/tnZMeIa5ROOZ280o5OfY" alt="Egyptian"></img>
                                    </div>
                                </div>
                                <h1>Egyptian</h1>
                            </button>
                            <button width="100" className={"WidthSelectorCard " + (this.state['Step4of5'] == "Celtic" ? "active-class" : "")} onClick={this.handleChange('Step4of5')} value="Celtic">
                                <div width="100" shape="circle" className="WidthImageContainerContainer" >
                                    <div className="WidthImageContainer">
                                        <img className="WidthImage" src="https://d33x1o3gj9io8i.cloudfront.net/images/3194/oUEegG3lSCmOX65c12Df" alt="Celtic"></img>
                                    </div>
                                </div>
                                <h1>Celtic</h1>
                            </button>
                        </div>
                        <div className="QuestionNavigationContainer" delay="450">
                            <button className="QuestionNavigationButton" onClick={this.prevStep} style={{ marginRight: '150px' }}>
                                <span>Back</span>
                                <svg width="16px" height="16px" viewBox="0 0 14 12" version="1.1"><title>Back</title><g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"><g id="Next/Back-Buttons" transform="translate(0.000000, -54.000000)" fill="#000000" fillRule="nonzero" stroke="#000000"><g id="Group" transform="translate(0.000000, 50.000000)"><path d="M7.02814142,4 C7.10303865,4.00628851 7.17617741,4.03773106 7.2334898,4.09432766 L11.9032854,8.70580175 C12.0322382,8.83314409 12.0322382,9.03960679 11.9032854,9.16694917 C11.7743325,9.29429148 11.5652587,9.29429148 11.4363058,9.16694917 L7.33008912,5.11198996 L7.33104051,16.4516973 L7.32572085,16.5103293 C7.29776369,16.6624347 7.1629516,16.7777778 7.00085901,16.7777778 C6.81848843,16.7777778 6.67064429,16.6317903 6.67063168,16.4516973 L6.6696803,5.11198996 L2.56369419,9.16694917 C2.44906944,9.28014233 2.27113919,9.29271938 2.14244655,9.2046802 L2.09671464,9.16694917 C1.96776179,9.03960679 1.96776179,8.83314409 2.09671464,8.70580175 L6.76651023,4.09432766 C6.82382262,4.03773106 6.89696138,4.00628851 6.97185861,4 L7.02814142,4 Z" id="Path" transform="translate(7.000000, 10.388889) rotate(-90.000000) translate(-7.000000, -10.388889) "></path></g></g></g></svg>
                            </button>
                            <button className={"QuestionNavigationButton " + (this.state['Step4of5'] == "" ? "disabled" : "false")} onClick={this.state['Step4of5'] != "" ? this.nextStep : ""}>
                                <span>Next</span>
                                <svg width="16px" height="16px" viewBox="0 0 14 12" version="1.1"><title>Next</title><g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"><g id="Next/Back-Buttons" transform="translate(-263.000000, -54.000000)" fill="#000000" fillRule="nonzero" stroke="#000000"><g id="Group-3-Copy" transform="translate(0.000000, 50.000000)"><g id="Group-2" transform="translate(214.000000, 0.000000)"><path d="M56.0281414,4 C56.1030387,4.00628851 56.1761774,4.03773106 56.2334898,4.09432766 L60.9032854,8.70580175 C61.0322382,8.83314409 61.0322382,9.03960679 60.9032854,9.16694917 C60.7743325,9.29429148 60.5652587,9.29429148 60.4363058,9.16694917 L56.3300891,5.11198996 L56.3310405,16.4516973 L56.3257208,16.5103293 C56.2977637,16.6624347 56.1629516,16.7777778 56.000859,16.7777778 C55.8184884,16.7777778 55.6706443,16.6317903 55.6706317,16.4516973 L55.6696803,5.11198996 L51.5636942,9.16694917 C51.4490694,9.28014233 51.2711392,9.29271938 51.1424466,9.2046802 L51.0967146,9.16694917 C50.9677618,9.03960679 50.9677618,8.83314409 51.0967146,8.70580175 L55.7665102,4.09432766 C55.8238226,4.03773106 55.8969614,4.00628851 55.9718586,4 L56.0281414,4 Z" id="Path-Copy" transform="translate(56.000000, 10.388889) rotate(-270.000000) translate(-56.000000, -10.388889) "></path></g></g></g></g></svg>
                            </button>
                        </div>
                    </div>
                )
            case 6:
                return (
                    <div className="StepContainer">
                        <div className="StepQuestion">
                            <h3 delay="0">5 of 5</h3>
                            <h1 delay="150">Do you have a bunion on your feet? (Choose as many as you like)</h1>
                        </div>
                        <div className="ShoeSizeSelectorContainer" delay="400">
                            <button width="100" bump="left" className={"WidthSelectorCard " + (this.handleCheck("A") == true ? "active-class" : "")} onClick={this.handleChange('Step5of5')} value="A">
                                <div width="100" shape="circle" className="WidthImageContainerContainer" >
                                    <div className="WidthImageContainer">
                                        <img className="WidthImage" src="https://d33x1o3gj9io8i.cloudfront.net/images/3194/jYNiDmsiR0iPtojAAcdv" alt="Bump on inside left"></img>
                                    </div>
                                </div>
                                <h1>Bump on inside left</h1>
                            </button>
                            <button width="100" bump="right" className={"WidthSelectorCard " + (this.handleCheck("B") == true ? "active-class" : "")} onClick={this.handleChange('Step5of5')} value="B">
                                <div width="100" shape="circle" className="WidthImageContainerContainer" >
                                    <div className="WidthImageContainer">
                                        <img className="WidthImage" src="https://d33x1o3gj9io8i.cloudfront.net/images/3194/OCmxsg8T3G8lrhMsq457" alt="Bump on inside right"></img>
                                    </div>
                                </div>
                                <h1>Bump on inside right</h1>
                            </button>
                            <button width="100" bump="both" className={"WidthSelectorCard " + (this.handleCheck("C") == true ? "active-class" : "")} onClick={this.handleChange('Step5of5')} value="C">
                                <div width="100" shape="circle" className="WidthImageContainerContainer" >
                                    <div className="WidthImageContainer">
                                        <img className="WidthImage" src="https://d33x1o3gj9io8i.cloudfront.net/images/3194/ruWwDdG6QuyYqroWUEKW" alt="Bump on both inside"></img>
                                    </div>
                                </div>
                                <h1>Bump on both inside</h1>
                            </button>
                            <button width="100" bump="left" className={"WidthSelectorCard " + (this.handleCheck("D") == true ? "active-class" : "")} onClick={this.handleChange('Step5of5')} value="D">
                                <div width="100" shape="circle" className="WidthImageContainerContainer" >
                                    <div className="WidthImageContainer">
                                        <img className="WidthImage" src="https://d33x1o3gj9io8i.cloudfront.net/images/3194/ZcT5cYQfQ52KOx6U63fd" alt="Bump on outside left"></img>
                                    </div>
                                </div>
                                <h1>Bump on outside left</h1>
                            </button>
                            <button width="100" bump="right" className={"WidthSelectorCard " + (this.handleCheck("E") == true ? "active-class" : "")} onClick={this.handleChange('Step5of5')} value="E">
                                <div width="100" shape="circle" className="WidthImageContainerContainer" >
                                    <div className="WidthImageContainer">
                                        <img className="WidthImage" src="https://d33x1o3gj9io8i.cloudfront.net/images/3194/5Eteu3k5TNCp4Ex2iHyA" alt="Bump on outside right"></img>
                                    </div>
                                </div>
                                <h1>Bump on outside right</h1>
                            </button>
                            <button width="100" bump="both" className={"WidthSelectorCard " + (this.handleCheck("F") == true ? "active-class" : "")} onClick={this.handleChange('Step5of5')} value="F">
                                <div width="100" shape="circle" className="WidthImageContainerContainer" >
                                    <div className="WidthImageContainer">
                                        <img className="WidthImage" src="https://d33x1o3gj9io8i.cloudfront.net/images/3194/IW88f2JRlqHwc8if1bow" alt="Bump on both outside"></img>
                                    </div>
                                </div>
                                <h1>Bump on both outside</h1>
                            </button>
                            <button width="100" bump="none" className={"WidthSelectorCard " + (this.handleCheck("G") == true ? "active-class" : "")} onClick={this.handleChange('Step5of5')} value="G">
                                <div width="100" shape="circle" className="WidthImageContainerContainer" >
                                    <div className="WidthImageContainer">
                                        <img className="WidthImage" src="https://d33x1o3gj9io8i.cloudfront.net/images/3194/uVG1TD0RQhmh4T6wzV95" alt="No bumps"></img>
                                    </div>
                                </div>
                                <h1>No bumps</h1>
                            </button>
                        </div>
                        <div className="QuestionNavigationContainer" delay="450">
                            <button className="QuestionNavigationButton" onClick={this.prevStep} style={{ marginRight: '150px' }}>
                                <span>Back</span>
                                <svg width="16px" height="16px" viewBox="0 0 14 12" version="1.1"><title>Back</title><g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"><g id="Next/Back-Buttons" transform="translate(0.000000, -54.000000)" fill="#000000" fillRule="nonzero" stroke="#000000"><g id="Group" transform="translate(0.000000, 50.000000)"><path d="M7.02814142,4 C7.10303865,4.00628851 7.17617741,4.03773106 7.2334898,4.09432766 L11.9032854,8.70580175 C12.0322382,8.83314409 12.0322382,9.03960679 11.9032854,9.16694917 C11.7743325,9.29429148 11.5652587,9.29429148 11.4363058,9.16694917 L7.33008912,5.11198996 L7.33104051,16.4516973 L7.32572085,16.5103293 C7.29776369,16.6624347 7.1629516,16.7777778 7.00085901,16.7777778 C6.81848843,16.7777778 6.67064429,16.6317903 6.67063168,16.4516973 L6.6696803,5.11198996 L2.56369419,9.16694917 C2.44906944,9.28014233 2.27113919,9.29271938 2.14244655,9.2046802 L2.09671464,9.16694917 C1.96776179,9.03960679 1.96776179,8.83314409 2.09671464,8.70580175 L6.76651023,4.09432766 C6.82382262,4.03773106 6.89696138,4.00628851 6.97185861,4 L7.02814142,4 Z" id="Path" transform="translate(7.000000, 10.388889) rotate(-90.000000) translate(-7.000000, -10.388889) "></path></g></g></g></svg>
                            </button>
                            <button className={"QuestionNavigationButton " + (this.state['Step5of5'].length == 0 ? "disabled" : "false")} onClick={this.state['Step5of5'].length > 0 ? this.nextStep : ""}>
                                <span>Next</span>
                                <svg width="16px" height="16px" viewBox="0 0 14 12" version="1.1"><title>Next</title><g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"><g id="Next/Back-Buttons" transform="translate(-263.000000, -54.000000)" fill="#000000" fillRule="nonzero" stroke="#000000"><g id="Group-3-Copy" transform="translate(0.000000, 50.000000)"><g id="Group-2" transform="translate(214.000000, 0.000000)"><path d="M56.0281414,4 C56.1030387,4.00628851 56.1761774,4.03773106 56.2334898,4.09432766 L60.9032854,8.70580175 C61.0322382,8.83314409 61.0322382,9.03960679 60.9032854,9.16694917 C60.7743325,9.29429148 60.5652587,9.29429148 60.4363058,9.16694917 L56.3300891,5.11198996 L56.3310405,16.4516973 L56.3257208,16.5103293 C56.2977637,16.6624347 56.1629516,16.7777778 56.000859,16.7777778 C55.8184884,16.7777778 55.6706443,16.6317903 55.6706317,16.4516973 L55.6696803,5.11198996 L51.5636942,9.16694917 C51.4490694,9.28014233 51.2711392,9.29271938 51.1424466,9.2046802 L51.0967146,9.16694917 C50.9677618,9.03960679 50.9677618,8.83314409 51.0967146,8.70580175 L55.7665102,4.09432766 C55.8238226,4.03773106 55.8969614,4.00628851 55.9718586,4 L56.0281414,4 Z" id="Path-Copy" transform="translate(56.000000, 10.388889) rotate(-270.000000) translate(-56.000000, -10.388889) "></path></g></g></g></g></svg>
                            </button>
                        </div>
                    </div>
                )
            case 7:
                return (
                    <div className="StepContainer">
                        <h3 delay="0">Confirmation</h3>
                        <h1 delay="150">Please enter your email!</h1>
                        <div className="ShoeSizeSelectorContainer2 d-flex justify-content-center">
                            <input className="ml-1 fs-5" id="userEmail" type="email" onInput={this.handleChange('email')} value={this.state['email']}></input>
                        </div>
                        <div className="QuestionNavigationContainer" delay="450">
                            <button className="QuestionNavigationButton" onClick={this.prevStep} style={{ marginRight: '150px' }}>
                                <span>Back</span>
                                <svg width="16px" height="16px" viewBox="0 0 14 12" version="1.1"><title>Back</title><g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"><g id="Next/Back-Buttons" transform="translate(0.000000, -54.000000)" fill="#000000" fillRule="nonzero" stroke="#000000"><g id="Group" transform="translate(0.000000, 50.000000)"><path d="M7.02814142,4 C7.10303865,4.00628851 7.17617741,4.03773106 7.2334898,4.09432766 L11.9032854,8.70580175 C12.0322382,8.83314409 12.0322382,9.03960679 11.9032854,9.16694917 C11.7743325,9.29429148 11.5652587,9.29429148 11.4363058,9.16694917 L7.33008912,5.11198996 L7.33104051,16.4516973 L7.32572085,16.5103293 C7.29776369,16.6624347 7.1629516,16.7777778 7.00085901,16.7777778 C6.81848843,16.7777778 6.67064429,16.6317903 6.67063168,16.4516973 L6.6696803,5.11198996 L2.56369419,9.16694917 C2.44906944,9.28014233 2.27113919,9.29271938 2.14244655,9.2046802 L2.09671464,9.16694917 C1.96776179,9.03960679 1.96776179,8.83314409 2.09671464,8.70580175 L6.76651023,4.09432766 C6.82382262,4.03773106 6.89696138,4.00628851 6.97185861,4 L7.02814142,4 Z" id="Path" transform="translate(7.000000, 10.388889) rotate(-90.000000) translate(-7.000000, -10.388889) "></path></g></g></g></svg>
                            </button>
                            <button className={"QuestionNavigationButton " + (this.state['email'].length == 0 ? "disabled" : "false")} onClick={this.state['email'].length > 0 ? this.nextStep : ""}>
                                <span>Submit</span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-shop-window" viewBox="0 0 16 16">
                                    <path d="M2.97 1.35A1 1 0 0 1 3.73 1h8.54a1 1 0 0 1 .76.35l2.609 3.044A1.5 1.5 0 0 1 16 5.37v.255a2.375 2.375 0 0 1-4.25 1.458A2.371 2.371 0 0 1 9.875 8 2.37 2.37 0 0 1 8 7.083 2.37 2.37 0 0 1 6.125 8a2.37 2.37 0 0 1-1.875-.917A2.375 2.375 0 0 1 0 5.625V5.37a1.5 1.5 0 0 1 .361-.976l2.61-3.045zm1.78 4.275a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 1 0 2.75 0V5.37a.5.5 0 0 0-.12-.325L12.27 2H3.73L1.12 5.045A.5.5 0 0 0 1 5.37v.255a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0zM1.5 8.5A.5.5 0 0 1 2 9v6h12V9a.5.5 0 0 1 1 0v6h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1V9a.5.5 0 0 1 .5-.5zm2 .5a.5.5 0 0 1 .5.5V13h8V9.5a.5.5 0 0 1 1 0V13a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.5a.5.5 0 0 1 .5-.5z" />
                                </svg>
                            </button>
                        </div>
                    </div>
                )
            case 8:
                return (
                    <div className="StepContainer">
                        <h3 delay="0">Complete</h3>
                        <h1 delay="150">Your Fit Finder Results* Are In!</h1>
                        <h2 className={"text-primary " + (this.algorithm().widthCorD == false ? "d-none" : "")} delay="150"><b>Your widths are {(this.algorithm().WidthLeft)} and {(this.algorithm().WidthRight)}.</b> You will receive an email notification once they become available.</h2>
                        <div className="ShoeSizeSelectorContainer results-container d-flex align-items-center justify-content-between text-center">
                            <div className="d-flex flex-column result-column">
                                <h2 className="result-spacer"> </h2>
                                <h2>Left</h2>
                                <h2>Right</h2>
                            </div>
                            <div className="d-flex flex-column">
                                <h2>Size</h2>
                                <h2><b>{(this.algorithm().SizeLeft)}</b></h2>
                                <h2><b>{(this.algorithm().SizeRight)}</b></h2>
                            </div>
                            <div className="d-flex flex-column result-column">
                                <h2>Width</h2>
                                <h2><b>{(this.algorithm().WidthLeft)}</b></h2>
                                <h2><b>{(this.algorithm().WidthRight)}</b></h2>
                            </div>
                        </div> 
                        <div className="d-flex flex-column align-items-center justify-content-center">
                            <h3 className="text-danger" style={{ margin: "20px auto 0px" }} delay="150">*If the widths or size/length is different above for the right and left shoe, order with the longest size/widest width available.
                                If a size/width is unavailable, select the longest/widest size closest to your range listed above.
Any questions, reach out to us: <a href="mailto:hello@antoniasaintny.com">hello@antoniasaintny.com</a></h3>
                            <button className="LandingScreenButton mt-3" onClick={this.shopNow} kind="fill">SHOP NOW</button>
                        </div>
                        <div className="QuestionNavigationContainer" delay="450">
                            <button className="QuestionNavigationButton" onClick={this.prevStep}>
                                <span>Back</span>
                                <svg width="16px" height="16px" viewBox="0 0 14 12" version="1.1"><title>Back</title><g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"><g id="Next/Back-Buttons" transform="translate(0.000000, -54.000000)" fill="#000000" fillRule="nonzero" stroke="#000000"><g id="Group" transform="translate(0.000000, 50.000000)"><path d="M7.02814142,4 C7.10303865,4.00628851 7.17617741,4.03773106 7.2334898,4.09432766 L11.9032854,8.70580175 C12.0322382,8.83314409 12.0322382,9.03960679 11.9032854,9.16694917 C11.7743325,9.29429148 11.5652587,9.29429148 11.4363058,9.16694917 L7.33008912,5.11198996 L7.33104051,16.4516973 L7.32572085,16.5103293 C7.29776369,16.6624347 7.1629516,16.7777778 7.00085901,16.7777778 C6.81848843,16.7777778 6.67064429,16.6317903 6.67063168,16.4516973 L6.6696803,5.11198996 L2.56369419,9.16694917 C2.44906944,9.28014233 2.27113919,9.29271938 2.14244655,9.2046802 L2.09671464,9.16694917 C1.96776179,9.03960679 1.96776179,8.83314409 2.09671464,8.70580175 L6.76651023,4.09432766 C6.82382262,4.03773106 6.89696138,4.00628851 6.97185861,4 L7.02814142,4 Z" id="Path" transform="translate(7.000000, 10.388889) rotate(-90.000000) translate(-7.000000, -10.388889) "></path></g></g></g></svg>
                            </button>
                        </div>
                    </div>
                )
            default:
            // do nothing
        }
    }
}


